import { useTranslation } from 'react-i18next';
import { FlowWithDocument } from '~/types/flow';
import { isDefined } from '~/types/typeGuards';
import { extractFlowNumber } from '~/utils/flow';

export const FlowIndex = ({ flow }: { flow: FlowWithDocument }) => {
  const { t } = useTranslation('reconciliations');
  const { index, count } = extractFlowNumber(flow);

  if (isDefined(index) && isDefined(count)) return t('flow_index', { index, count });

  return '';
};
